import { render, staticRenderFns } from "./FabricSaleGraph.vue?vue&type=template&id=038e3674"
import script from "./FabricSaleGraph.vue?vue&type=script&lang=js"
export * from "./FabricSaleGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports